import { render, staticRenderFns } from "./interfaccia.vue?vue&type=template&id=86a54808&scoped=true&"
import script from "./interfaccia.vue?vue&type=script&lang=js&"
export * from "./interfaccia.vue?vue&type=script&lang=js&"
import style0 from "./interfaccia.vue?vue&type=style&index=0&id=86a54808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a54808",
  null
  
)

export default component.exports